const riot = require('riot');

riot.tag2('page-auth', '<div class="s-full f fh"> <div class="f fh fclm bg-white py32 px70 rounded-8"> <h1 class="text-center lh15 fs24 text-primary mb24">{labels.title}</h1> <button class="button primary f fh h40 w-full transition mb24" onclick="{onSignInWithProvider}"><img class="block object-fit-contain s16 mr8" src="/images/sns/google_color.svg"> <div class="lh15 fs14 text-primary fw4">Googleで{labels.title}</div> </button> <div class="f fm w-full mb24"> <div class="h1 w-full bg-separator_opaque"></div> <div class="text-label_medium word-break-keep fs12 mx16">または</div> <div class="h1 w-full bg-separator_opaque"></div> </div> <form class="f fclm mb16" onsubmit="{onSubmit}"> <input class="border h40 w280 px8 rounded-4 mb16" ref="email" placeholder="メールアドレス" required type="email"> <input class="border h40 w280 px8 rounded-4 mb16" ref="password" type="password" placeholder="パスワード" required> <button class="button primary_fill h40 w-full">{labels.title}</button> </form> <div class="lh15 fs11 text-label_high text-decoration-underline cursor-pointer mb16" if="{mode === \'signin\'}" onclick="{onPasswordReset}">パスワードを忘れた場合</div><a class="lh15 fs11 text-primary" href="{labels.other.link}">{labels.other.label}</a> </div> </div>', 'page-auth,[data-is="page-auth"]{display:block}', '', function(opts) {
    this.providers = [
      { id:'twitter' },
      { id:'facebook' },
      { id:'google' },
    ];

    this.preload = ({req, res}) => {
      var mode = req.params.auth_mode;

      return {
        mode,
      };
    };

    this.on('show', () => {
      if (spat.config.env !== 'production') {
        this.refs.email.value = 'development@rabee.jp';
        this.refs.password.value = 'hogehoge';
      }

      if (this.mode === 'signup') {
        this.labels = {
          title: '新規登録',
          other: {
            label: 'ログイン',
            link: '/signin',
          },
        };
      }
      else {
        this.labels = {
          title: 'ログイン',
          other: {
            label: '新規登録',
            link: '/signup',
          },
        };
      }
    });

    this.onSubmit = async (e) => {
      e.preventDefault();
      var i = spat.modal.indicator();

      var email = this.refs.email.value;
      var password = this.refs.password.value;

      try {
        if (this.mode === 'signup') {
          await app.auth.createUserWithEmailAndPassword(email, password);
        }
        else {

          await app.auth.signInWithEmailAndPassword(email, password);
        }
        spat.router.push('/');
      }
      finally {
        i.close();
      }
    };

    this.onSignInWithProvider = (e) => {
      e.preventDefault();

      var provider_id = 'google';

      const Provider = {

        'google': firebase.auth.GoogleAuthProvider,
      }[provider_id];
      var provider = new Provider();

      app.auth.signInWithRedirect(provider);
    };

    this.onPasswordReset = () => {
      spat.router.push("/password-reset");
    };
});